<page-headline
    [linkTitle]="'Incentives Home'"
    [module]="'incentives'"
    [moduleIcon]="'fa-dollar-sign'"
    [moduleLink]="'incentives'"
    [pageTitle]="'CompenSafe'"
>
</page-headline>

<p>
    This page is a placeholder.
</p>
